import { Col, Row } from "reactstrap"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import FilterInTable from "../../../../Manage/FilterInTable"
import ManageTable from "../../../../Manage/ManageTable"

const MaelanoWalletActivity = ({ setShowMaelanoActivity }) => {
  const data = [
    {
      dateAndTime: { date: "2024-10-14", time: "09:30 AM" },
      transactionType: "Credit",
      description: "Top-up via Credit Card",
      amount: "+$50.00",
      balanceAfterTransaction: "$150.00",
      status: "Pending",
    },
    {
      dateAndTime: { date: "2024-10-14", time: "09:30 AM" },
      transactionType: "Debit",
      description: "Order Payment (Order #12345)",
      amount: "-$20.00",
      balanceAfterTransaction: "$100.00",
      status: "Completed",
    },
    {
      dateAndTime: { date: "2024-10-14", time: "09:30 AM" },
      transactionType: "Credit",
      description: "Top-up via Credit Card",
      amount: "+$50.00",
      balanceAfterTransaction: "$150.00",
      status: "Completed",
    },
  ]

  const columns = [
    {
      name: "Date and Time",
      cell: (row) => (
        <div>
          <div>{row.dateAndTime.date}</div>
          <div>{row.dateAndTime.time}</div>
        </div>
      ),
      sortable: true
    },
    { name: "Transaction Type", selector: (row) => row.transactionType },
    { name: "Description", selector: (row) => row.description },
    { name: "Amount (+/-)", selector: (row) => row.amount },
    { name: "Balance After Transaction", selector: (row) => row.balanceAfterTransaction },
    {
      name: "Status",
      cell: (row) => {
        let color = ""
        switch (row.balanceAfterTransaction) {
          case "Pending":
            color = "#EC7426"
            break
          case "Completed":
            color = "#41B8E4"
            break
          default:
            break
        }

        return <div style={{ color }}>{row.balanceAfterTransaction}</div>
      },
    },
  ]

  return (
    <Row noGutters>
      <Col xs='12' md='1'>
        <div className="p-md-3 cursor-pointer fw-medium" onClick={() => setShowMaelanoActivity(false)}>
        <i className="fa fas fa-caret-left"></i> BACK
        </div>
      </Col>
      <Col xs='12' md='11'>
        <div className="my-3">
          <div className="fw-bold fs-4 text-center">Maelano Wallet Activity</div>
          <div className="my-3">
            <FilterInTable componentName="Maelano Wallet Activity" />
          </div>
          <DatatableComponent columns={columns} data={data} responsive type={"gray"} />
        </div>
      </Col>
    </Row>
  )
}

export default MaelanoWalletActivity
